var map = {
	"./alliance-draenei-female.jpg": 95641,
	"./alliance-draenei-male.jpg": 52910,
	"./alliance-dwarf-female.jpg": 89501,
	"./alliance-dwarf-male.jpg": 59695,
	"./alliance-gnome-female.jpg": 2708,
	"./alliance-gnome-male.jpg": 22583,
	"./alliance-human-female.jpg": 35908,
	"./alliance-human-male.jpg": 5662,
	"./alliance-night-elf-female.jpg": 15296,
	"./alliance-night-elf-male.jpg": 69494,
	"./alliance-pandaren-female.jpg": 58055,
	"./alliance-pandaren-male.jpg": 34653,
	"./alliance-worgen-female.jpg": 77939,
	"./alliance-worgen-male.jpg": 24189,
	"./horde-blood-elf-female.jpg": 37755,
	"./horde-blood-elf-male.jpg": 32044,
	"./horde-goblin-female.jpg": 78638,
	"./horde-goblin-male.jpg": 67054,
	"./horde-orc-female.jpg": 73687,
	"./horde-orc-male.jpg": 63652,
	"./horde-pandaren-female.jpg": 10460,
	"./horde-pandaren-male.jpg": 88010,
	"./horde-tauren-female.jpg": 30322,
	"./horde-tauren-male.jpg": 991,
	"./horde-troll-female.jpg": 68113,
	"./horde-troll-male.jpg": 42253,
	"./horde-undead-female.jpg": 84416,
	"./horde-undead-male.jpg": 19104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10688;